import _ from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import HFMDragDropContext from '../hfm-drag-drop-context';

const filterSelectedSongs = (selectedSongs = [], songList) => {
	return songList.filter((song) => {
		return selectedSongs.map(({ _id }) => _id).indexOf(song._id) === -1;
	});
};

const filterSelectedItems = (selectedItems = [], itemList) => {
	return itemList.filter((item) => {
		return selectedItems.map(({ _id }) => _id).indexOf(item._id) === -1;
	});
};

const ArtistListItem = ({ _id, artistName, onClick, icon }) => {
	return (
		<div className="grid-x align-middle" data-ta="songListItem">
			<div className="cell small shrink">
				<button
					key={ _id }
					data-id={ _id }
					data-ta="addSongBtn"
					onClick={ onClick }
					style={{
						textAlign: 'left'
					}}
					className="button secondary clear expanded margin-bottom-0">
						<span
							className={ `fas fa-${icon}` }
							style={{
								margin: '0',
								float: 'left'
							}}>
						</span>
				</button>
			</div>
			<div className="cell small auto" style={{fontSize:'1.25em'}}>
				<b>{ artistName }</b>
			</div>
		</div>
	);
};

const AlbumListItem = ({ _id, artistName, name, onClick, icon }) => {
	return (
		<div className="grid-x align-middle" data-ta="albumListItem">
			<div className="cell small shrink">
				<button
					key={ _id }
					data-id={ _id }
					data-ta="addAlbumBtn"
					onClick={ onClick }
					style={{
						textAlign: 'left'
					}}
					className="button secondary clear expanded margin-bottom-0">
						<span
							className={ `fas fa-${icon}` }
							style={{
								margin: '0',
								float: 'left'
							}}>
						</span>
				</button>
			</div>
			<div className="cell small auto">
				<b>{ name }</b>
				<br />
				<em>{ artistName }</em>
			</div>
		</div>
	);
};

const SongListItem = ({ _id, title, artistName, onClick, icon }) => {
	return (
		<div className="grid-x align-middle" data-ta="songListItem">
			<div className="cell small shrink">
				<button
					key={ _id }
					data-id={ _id }
					data-ta="addSongBtn"
					onClick={ onClick }
					style={{
						textAlign: 'left'
					}}
					className="button secondary clear expanded margin-bottom-0">
						<span
							className={ `fas fa-${icon}` }
							style={{
								margin: '0',
								float: 'left'
							}}>
						</span>
				</button>
			</div>
			<div className="cell small auto">
				<div className="abcd">{ title }</div>
				<br />
				<em>{ artistName }</em>
			</div>
		</div>
	);
};


const ListFilter = ({ list, searchChange }) => {
	return (
		<div>
			MAG 
			<input type="text" data-ta={ list + "Filter" } id={ list + "Filter" } onChange={ searchChange(list) }/>
		</div>
	);
};

const ArtistList = ({ artists, icon, ItemOnClick, cellSize, filterable, searchChange }) => {
	return (
	<div className={ `cell small-${ cellSize }` } >
		{/* <ListFilter searchChange={ searchChange } /> */}
		<div>
			MAG 
			<input type="text" data-ta="ARTISTListFilter" id="ARTISTListFilter" onChange={ searchChange }/>
		</div>
		<h5>Artist List</h5>
		<div className="dnd-song-list" data-ta="ARTISTList" id="ARTISTList">
			{
				artists.map(({ name, _id }) => (
					<ArtistListItem
						key={ _id }
						id={ _id }
						icon={ icon }
						onClick={ ItemOnClick }
						artistName={ name } />
				))
			}
		</div>
	</div>
	);
};

const AlbumList = ({ albums, icon, ItemOnClick, cellSize, filterable, searchChange , getArtistName }) => {
	return (
	<div className={ `cell small-${ cellSize }` } >
		{/* <ListFilter listId={ "albumList" } searchChange={ searchChange } /> */}
		{/* <div>
			MAG Search Box goes here!!
		</div> */}
		<h5>Album List</h5>
		<div className="dnd-album-list" data-ta="albumList" id="albumList">
			{
				albums.map(({ _id, artistID, name }) => (
					<AlbumListItem
						key={ _id }
						id={ _id }
						icon={ icon }
						onClick={ ItemOnClick }
						artistName= { this.getArtistName(artistID) }
						name={ name }  />
				))
			}
		</div>
	</div>
	);
};

const SongsList = ({ songs, icon, ItemOnClick, cellSize, filterable, searchChange , getArtistName }) => {
	return (
	<div className={ `cell small-${ cellSize }` } >
		<input type="text" data-ta="SONGListFilter" id="SONGListFilter" onChange={ searchChange }/>
		{/* <ListFilter listId={ "songList" } searchChange={ searchChange("songList") } /> */}
		{/* <div>
			MAG Search Box goes here
		</div> */}
		<h5>Song List</h5>
		<div className="dnd-song-list" data-ta="SONGList" id="SONGList">
			{
				songs.map(({ _id, title, artistID }) => (
					<SongListItem
						key={ _id }
						id={ _id }
						title={ title }
						icon={ icon }
						onClick={ ItemOnClick }
						artistName={ getArtistName(artistID) } />
						// this.getArtistName(artistID) 
				))
			}
		</div>
	</div>
	);
};




@inject('artistStore')
@observer
class ItemList extends Component {
	// Normally you would want to split things out into separate components.
	// But in this example everything is just done in one place for simplicity
	render() {
		// const { itemList, selectedItems } = this.props;
		// const { listType } = this.props;
		// const items = filterSelectedItems(selectedItems, itemList);

		const { listType } = this.props;
		const { itemList, selectedItems } = this.props;
		const numCells = 2;
		const cellSize = 12 / numCells;
		// const { songList, selectedSongs } = this.props;
		// const { albumsList, selectedAlbums } = this.props;
		// const { artistList, selectedArtists } = this.props;

		const items = filterSelectedItems(selectedItems, itemList);

		// const songs = filterSelectedItems(selectedSongs, songList);
		// const albums = filterSelectedItems(selectedAlbums, albumsList);
		// const album = _.uniqBy(_.uniqBy(songs, 'artistID'), 'artistID');
		// const artists = _.uniqBy(songs, 'artistID');
		// const artists = filterSelectedItems(selectedArtists, artistList);

		// const selectedArtists = [];
		// console.log(albumsList);
		let muzadoListBox = false;
		if (listType == "ARTIST") {
			items.sort(function (x, y) {
				let a = x.name.toUpperCase(),
					b = y.name.toUpperCase();
				return a == b ? 0 : a > b ? 1 : -1;
			});
			muzadoListBox = 
				<ArtistList
					artists={ items }
					icon="plus"
					ItemOnClick={ this.addItem }
					cellSize={ cellSize }
					filterable={ true }  
					searchChange={ this.searchArtistChange } 
				/>

		} else if (listType == "ALBUM") {
			muzadoListBox = 
				<AlbumList
					albums={ items }
					icon="plus"
					ItemOnClick={ this.addItem }
					cellSize={ cellSize }
					nameFunc={ this.getArtistName }
					filterable={ true }  
					searchChange={ this.searchAlbumChange }
					getArtistName={ this.getArtistName }
				/>
		} else if (listType == "PLAYLIST" || listType == "SONG") {
			// items.sort(function (x, y) {
			// 	let a = x.title.toUpperCase(),
			// 		b = y.title.toUpperCase();
			// 	return a == b ? 0 : a > b ? 1 : -1;
			// });
			muzadoListBox = 
				<SongsList
					songs={ items }
					icon="plus"
					ItemOnClick={ this.addItem }
					cellSize={ cellSize }
					nameFunc={ this.getArtistName }
					filterable={ true } 
					searchChange={ this.searchSongChange }
					getArtistName={ this.getArtistName }
				/>
		}

		return (
			<div className="grid-x album-form-song-list">

				{ muzadoListBox }

				<div 
					className={ `cell small-${ cellSize }` } 
					data-ta="selectedSongs" >
					<div>
						MAG Search Box goes here
					</div>
					<h5>Selected Items</h5>
					<HFMDragDropContext
						dragDropList={ selectedItems }
						onDragEnd={ this.props.onDragEnd }
						ItemLabel={ (listType == "ARTIST" ? this.renderArtistLabel : (listType == "ALBUM" ? this.renderAlbumLabel : this.renderLabel)) }
						ItemButton={ this.renderRemoveButton } />
				</div>
			</div>
		);


	}

	// @autobind
	// selectArtist ({ target }) {
	// 	const { addSong } = this.props;
	// 	const el = target.localName === 'span' ? target.parentElement : target;
	// 	addSong(el.dataset._id);
	// }
	@autobind
	searchArtistChange ({ target }) {
		console.log(target.value);
		// let list = document.getElementById("ARTISTList""artistList").children;
		let list = document.getElementById("ARTISTList").children;
	
		// console.log(list)
		const rx = new RegExp(target.value, "ig");
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.textContent;
			if (txt.match(rx)) {
				console.log(txt);
				item.style = "visibility: visible;";
			} else {
				console.warn(txt);
				item.style = "visibility: collapse; height:0px !important";
			}
		}
	}

	@autobind
	searchSongChange ({ target }) {
		console.log(target.value);
		// let list = document.getElementById("ARTISTList""artistList").children;
		let list = document.getElementById("SONGList").children;
		// console.log(list)
		const rx = new RegExp(target.value, "ig");
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.textContent;
			if (txt.match(rx)) {
				console.log(txt);
				item.style = "visibility: visible;";
			} else {
				console.warn(txt);
				item.style = "visibility: collapse; height:0px !important;";
			}
		}
	}

	@autobind
	selItem ({ target }) {
		const { selItem } = this.props;
		const el = target.localName === 'span' ? target.parentElement : target;
		target.parentElement.style.backgroundColor="#000000";
		selItem(el.dataset.id);
	}

	@autobind
	addItem ({ target }) {
		const { addItem } = this.props;
		const el = target.localName === 'span' ? target.parentElement : target;
		console.log("el.dataset")
		console.log(el.dataset)
		addItem(el.dataset.id);
	}

	@autobind
	removeItem ({ target }) {
		const { removeItem } = this.props;
		const el = target.localName === 'span' ? target.parentElement : target;
		removeItem(el.dataset.id);
	}

	@autobind
	addSong ({ target }) { // LEGACY SHIM
		this.addItem ( target );
	}

	@autobind
	removeSong ({ target }) { // LEGACY SHIM
		this.removeItem ( target );
	}
	
	@autobind
	renderRemoveButton ({ _id }) {
		return (
			<button
				key={ _id }
				data-id={ _id }
				onClick={ this.removeItem }
				className="button secondary clear margin-bottom-0">
					<span className="fas fa-minus"></span>
			</button>
		);
	}

	// @autobind
	// renderLabel ({ title, _id }, listType) {
	// 	console.log(listType)
	// 	if (listType == "SONG") {
	// 		return this.renderSongLabel ( title, _id )
	// 	} else if (listType == "ALBUM") {
	// 		return this.renderAlbumLabel ( title, _id )
	// 	} else if (listType == "ARTIST") {
	// 		return this.renderArtistLabel ( title, _id )
	// 	} 
	// }

	@autobind
	// renderSongLabel ({ title, artistID }) {
	renderLabel ({ title, artistID }) {
		return (
			<div>
				<div>{ title }</div>
				<br />
				<em>{ this.getArtistName(artistID) }</em>
			</div>
		);
	}

	@autobind
	renderArtistLabel ({ name }) {
	// renderLabel ({ name }) {
		return (
			<div>
				{ name }
			</div>
		);
	}

	@autobind
	renderAlbumLabel ({ name, artistID }) {
	// renderLabel ({ name, artistID }) {
		return (
			<div>
				{ name }
				<br />
				<em>{ this.getArtistName(artistID) }</em>
			</div>
		);
	}

	@autobind
	getArtistName (artistID) {
		const { artistStore } = this.props;
		const artist = artistStore.getArtistByID(artistID);
		return _.isObject(artist) ? (<em>{ artist.name }</em>) : '-- Artist name not found --';
	}

}

export default ItemList;
